import React, { useRef, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./Sell.css";
import Page1 from "../../assets/images/seller_page-0001.png";
import Page2 from "../../assets/images/seller_page-0002.png";
import Page3 from "../../assets/images/seller_page-0003.png";
import Page4 from "../../assets/images/seller_page-0004.png";
import SignaturePad from "./Comp/SignaturePad";
import config from "../../config";
import StripeComponent from "./StripeComponent";
import successImage from "./../../assets/images/success.png";
import SellImages from "../SellImages";
import CloseIcon from "@mui/icons-material/Close";
import ZoomInIcon from "@mui/icons-material/ZoomIn";
import ZoomOutIcon from "@mui/icons-material/ZoomOut";
import Header from "../Header/Header";
import { Box, Container, Stepper, Step, StepLabel, Snackbar, Alert, CircularProgress, Modal, IconButton, Fade } from "@mui/material";
import SellWelcomeScreen from "./SellWelcomeScreen";
import PackagesList from "./PackagesList";
import { isAddressValid } from "../utils/GlobalFunctions";
import SingleFamily from "../../assets/svg/SingleFamily.svg";
import Condo from "../../assets/svg/Condo.svg";
import MultiFamily from "../../assets/svg/MultiFamily.svg";
import TownHouse from "../../assets/svg/TownHouse.svg";
import HomeInspectorConfirmation from "./../../assets/images/HomeInspectorConfirmation.png";
import { postApi } from "../AppApis";
import { getAddressComponent } from "../../helpers/Helper";
import PropertyAddressAutocomplete from "../../components/PropertyComponent/PropertyAddressAutocomplete";
import AppStoreIcon from "../../assets/images/app_store_icon.png";
import PlayStoreIcon from "../../assets/images/play_store_icon.png";
import { showErrorToast } from "../utils";
import { useProfile } from "../../contexts/ProfileContext";
import VerifyAccountPopup from "../../components/ListNowComponents/VerifyAccountPopup";
import PreviewPage from "../Preview/Preview";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import TypeSignatureArea from "./Comp/TypeSignatureArea";
import ContractPreviewModal from "../../components/ContractPreviewModal";

const tabs = [
    { id: 0, label: "Draw" },
    { id: 1, label: "Type" },
];

function Sell() {
    const { profileData } = useProfile();

    const navigate = useNavigate();
    const sigCanvasRef = useRef();
    const [transaction_id, setTransactionId] = useState(null);
    const [paymentSuccess, setPaymentSuccess] = useState(false);
    const [openSnackbar, setOpenSnackbar] = useState(false);
    const [value, setValue] = useState("Single_Family");
    const [nextLoading, setNextLoading] = useState(false);
    const [paymentLoading, setPaymentLoading] = useState(false);
    const [success, setSuccess] = useState(false);
    const [expandContract, setExpandContract] = useState(false);
    const [showContractModal, setShowContractModal] = useState(false);
    const [total_price, setTotal_price] = useState("");
    const [previewModal, setPreviewModal] = useState(null);
    const [isShowVerificaionPopup, setIsShowVerificaionPopup] = useState(false);
    const [data, setData] = useState({
        seller_address: "",
        latitude: 0.0,
        longitude: 0.0,
    });
    const [errorMessage, setErrorMessage] = useState("");
    const [activeStep, setActiveStep] = useState(1);
    const [imagesArr, setImagesArr] = useState([]);
    const [imagesForApi, setImagesForApi] = useState([]);
    const [labels, setLabels] = useState([]);
    const steps = [{ label: "Instructions" }, { label: "Pictures" }, { label: "Packages" }, { label: "Contract" }, { label: "Payment Info" }];
    const [signMethod, setSignMethod] = useState(0);
    const [isSigned, setIsSigned] = useState(false);
    const [typedSignature, setTypedSignature] = useState("");
    const [signatureColor, setSignatureColor] = useState("#000000");
    const [addressError, setAddressError] = useState("");
    const modalRef = useRef(null);
    const [zoomLevel, setZoomLevel] = useState(1);
    const [selected_items, setSelected_items] = useState([]);
    const [package_type, setPackage_type] = useState("");
    const [signatureData, setSignatureData] = useState(null);
    const [activePage, setActivePage] = useState(1);
    const [isAPiloading, setIsAPiloading] = useState(false);

    // Contract pages data for the enhanced modal
    const contractPages = [
        { type: 'image', src: Page1, id: 'page-1' },
        { type: 'image', src: Page2, id: 'page-2' },
        { type: 'canvas', id: 'page3-canvas', src: null },
        { type: 'image', src: Page4, id: 'page-4' }
    ];

    useEffect(() => {
        const getLocalStorageData = localStorage.getItem("sellAddress");
        if (getLocalStorageData) {
            setData(JSON.parse(getLocalStorageData).address);
            setValue(JSON.parse(getLocalStorageData).type);
        }
    }, []);

    const handleTypedSignatureChange = (event) => {
        setTypedSignature(event.target.value);
        setIsSigned(event.target.value.trim().length > 0);
        drawSignatureonPageThree();
    };

    const handleCloseExpandContract = () => {
        setExpandContract(false);
        setZoomLevel(1);
    };

    const handleOpenContractModal = () => {
        setShowContractModal(true);
    };

    const handleCloseContractModal = () => {
        setShowContractModal(false);
    };

    const handleZoomIn = () => {
        setZoomLevel((prevZoom) => Math.min(prevZoom + 0.1, 2));
    };

    const handleZoomOut = () => {
        setZoomLevel((prevZoom) => Math.max(prevZoom - 0.1, 1));
    };
    const propertyTypes = [
        { display: "Single Family", value: "Single_Family", icon: SingleFamily },
        { display: "Condo/Townhome", value: "Condo/Townhome", icon: Condo },
        { value: "Lots_acres_forms", display: "Lots Acres Forms", icon: TownHouse },
        { display: "Multifamily (2+ units)", value: "Multifamily", icon: MultiFamily },
    ];

    const handleSubmit = async (e) => {
        e.preventDefault();
    };

    const handleNext = async () => {
        setIsAPiloading(true);
        try {
            let canProceed = true;
            if (activeStep === 1 && (!data.seller_address.trim() || !isAddressValid(data.seller_address))) {
                if (!data.seller_address.trim()) {
                    showError("Address cannot be empty.");
                }
                if (!isAddressValid(data.seller_address)) {
                    setAddressError("Please enter a valid US address");
                }

                return;
            }

            // Step 1: Property details (address and type)
            if (activeStep === 1) {
                setNextLoading(true);

                const isSuccess = await addProperty({
                    address: data.seller_address,
                    PropertySubType: value,
                    latitude: data.latitude,
                    longitude: data.longitude,
                    project_type: "onmls",
                });

                setNextLoading(false);
                canProceed = isSuccess;
            }

            // Step 2: Upload Images
            if (activeStep === 2) {
                if (imagesArr.length > 0) {
                    setNextLoading(true);
                    if (imagesForApi.length > 0) {
                        const uploadSuccess = await uploadImages(); // Upload images, return success or failure
                        if (!uploadSuccess) {
                            showError("Failed to upload images. Please try again.");
                            return; // Stop if image upload fails
                        }
                    }
                }
                setNextLoading(false);
                canProceed = true;
            }

            // Step 4: Contract (Signature) validation
            if (activeStep === 4 && !isSigned) {
                showError("Please sign the document before proceeding.");
                return;
            }

            if (activeStep === 4 && isSigned) {
                setNextLoading(true);
                const signatureSaved = await saveSignatureOnServer();
                if (!signatureSaved) {
                    showError("Failed to save signature. Please try again.");
                    return;
                }
                setNextLoading(false);
                canProceed = true;
            }

            // Only proceed to the next step if everything succeeded
            if (canProceed) {
                const isLastStep = activeStep === 5;
                if (!isLastStep || paymentSuccess) {
                    if (activeStep === 4 && !total_price) {
                        if (profileData?.is_id_verified !== true) {
                            return setIsShowVerificaionPopup(true);
                        } else {
                            handlePaymentResponse(200);
                            setSuccess(true);
                        }
                        localStorage.removeItem("sellAddress");
                        localStorage.removeItem("sellImages");
                        localStorage.removeItem("newLocalData");
                        localStorage.removeItem("propertiesData");
                        localStorage.removeItem("transaction_id");
                        localStorage.removeItem("yardCount");
                        localStorage.removeItem("lockBoxesCount");
                        localStorage.removeItem("advertising_credits");
                    }
                    setActiveStep((prevActiveStep) => prevActiveStep + 1);
                } else {
                }
                setErrorMessage("");
            }
        } catch (err) {
            showError(err.message);
        } finally {
            setNextLoading(false);
            setIsAPiloading(false);
        }
    };

    const uploadImages = async () => {
        try {
            const accessToken = localStorage.getItem("authUser");
            const token = accessToken.replace(/^"|"$/g, "");

            const formData = new FormData();

            imagesForApi.forEach((uri) => {
                formData.append("images", uri);
            });
            labels.forEach((label) => {
                formData.append("labels[]", label);
            });
            formData.append("property_id", transaction_id);

            const api_url = `${config.get("API_URL")}/properties/upload_property_image`;

            const response = await fetch(api_url, {
                method: "POST",
                headers: {
                    Authorization: `Bearer ${token}`,
                },
                body: formData,
            });
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            await response.json();

            return true; // Return true to indicate success
        } catch (error) {
            console.error("Error while uploading images:", error);
            return false; // Return false to indicate failure
        }
    };

    const handleBack = () => {
        if (activeStep === 1) {
            navigate("/list-property/welcome");
        }
        if (activeStep === 2) {
            setIsSigned(false);
            if (sigCanvasRef.current) {
                sigCanvasRef.current.clear();
            }
        }
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
    };

    useEffect(() => {
        if (activeStep === 2) {
            setIsSigned(false);
            if (sigCanvasRef.current) {
                sigCanvasRef.current.clear();
            }
        }
    }, [activeStep]);

    useEffect(() => {
        document.title = `List Now | ${config.get("COMPANY_NAME")}`;
    }, []);

    const onCheckProperty = async () => {
        navigate("/MyProperties");
        // fetchProperties();
    };

    const handleClickOutside = (event) => {
        if (modalRef.current && !modalRef.current.contains(event.target)) {
            setExpandContract(false);
        }
    };

    useEffect(() => {
        if (expandContract) {
            document.addEventListener("mousedown", handleClickOutside);
        } else {
            document.removeEventListener("mousedown", handleClickOutside);
        }

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [expandContract]);

    const handleCloseSnackbar = (_, reason) => {
        if (reason === "clickaway") {
            return;
        }
        setOpenSnackbar(false);
    };

    const showError = (message) => {
        setErrorMessage(message);
        setOpenSnackbar(true);
    };

    const addProperty = async (body) => {
        try {
            const accessToken = localStorage.getItem("authUser");
            if (accessToken) {
                const addSellUrl = `/properties/create_property`;

                const response = await postApi(addSellUrl, { ...body, project_type: "onmls" });

                if (response.response) {
                    setTransactionId(response.response.property_id);
                    localStorage.setItem("transaction_id", response.response.property_id);
                    return response.response;
                }
                if (response.error === 401) {
                    navigate("/login");
                } else {
                    showErrorToast(response?.error?.detail || response?.response?.detail, {
                        autoClose: 3000,
                        pauseOnHover: false,
                    });
                }
            }
        } catch (error) {
            console.log(error.message);
            throw Error(error.message);
        }
    };

    const saveSignatureOnServer = async () => {
        try {
            const accessToken = localStorage.getItem("authUser");
            const token = accessToken.replace(/^"|"$/g, "");
            const formData = new FormData();
            let signature;

            if (signMethod === 0) {
                signature = sigCanvasRef.current.getTrimmedCanvas().toDataURL("image/png");
            } else if (signMethod === 1) {
                signature = typedSignature;
            }

            formData.append("property_id", transaction_id);
            formData.append("signature_data", signature);
            formData.append("project_type", "onmls");

            if (Number(total_price) === 0) {
                formData.append("package_type", package_type);
            }
            const url = `${config.get("API_URL")}/properties/upload_listing_contract`;
            const response = await fetch(url, {
                method: "POST",
                headers: {
                    Authorization: `Bearer ${token}`,
                },
                body: formData,
                credentials: "include",
            });

            if (!response.ok) {
                throw new Error(`Failed to save signature: ${response.status}`);
            }

            await response.json();
            if (Number(total_price) === 0) {
                localStorage.removeItem("sellAddress");
                localStorage.removeItem("sellImages");
                localStorage.removeItem("newLocalData");
                localStorage.removeItem("propertiesData");
                localStorage.removeItem("transaction_id");
                localStorage.removeItem("yardCount");
                localStorage.removeItem("lockBoxesCount");
                localStorage.removeItem("advertising_credits");
            }
            return true; // Return true to indicate success
        } catch (error) {
            console.error("Error saving signature:", error);
            return false; // Return false to indicate failure
        }
    };

    const handlePaymentResponse = (status) => {
        if (status === 200) {
            setPaymentSuccess(true);
            setActiveStep((prevActiveStep) => prevActiveStep + 1);
            setSuccess(true);
        } else {
            console.warn("Payment failed or incomplete. Status code:", status);

            // Provide optional user feedback on failure
            setPaymentSuccess(false);
            showError("Payment was unsuccessful. Please check your payment details and try again.");
        }
    };

    const drawImageOnCanvas = () => {
        const canvas = document.getElementById("page3-canvas");
        if (canvas) {
            const ctx = canvas.getContext("2d");
            const img = new Image();
            img.onload = () => {
                const aspectRatio = img.width / img.height;
                canvas.width = img.width;
                canvas.height = canvas.width / aspectRatio;
                ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

                // Redraw the stored signature (if it exists)
                if (signatureData && signMethod === 0) {
                    const signatureImg = new Image();
                    signatureImg.src = signatureData;
                    signatureImg.onload = () => {
                        const x = canvas.width / 6.5;
                        const y = canvas.height / 1.7;
                        ctx.drawImage(signatureImg, x, y);
                    };
                } else {
                    const x = canvas.width / 6.5;
                    const y = canvas.height / 1.6;
                    ctx.font = "30px cursive"; // or any signature-style font
                    ctx.fillStyle = signatureColor; // Use selected signature color

                    ctx.fillText(typedSignature, x, y);
                }

                // Redraw the date
                ctx.font = "bold 30px Arial";
                ctx.fillStyle = "red";
                const dateX = canvas.width / 1.26;
                const dateY = canvas.height / 1.62;
                ctx.fillText(new Date().toLocaleDateString(), dateX, dateY);
            };
            img.src = Page3;
        }
    };

    const drawSignatureonPageThree = () => {
        const canvas = document.getElementById("page3-canvas");
        if (canvas) {
            const ctx = canvas.getContext("2d");
            const img = new Image();
            img.onload = () => {
                const aspectRatio = img.width / img.height;
                canvas.width = img.width;
                canvas.height = canvas.width / aspectRatio;
                ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

                const x = canvas.width / 6.5;
                const y = canvas.height / 1.7;
                if (sigCanvasRef.current && signMethod === 0) {
                    const signatureCanvas = sigCanvasRef.current.getCanvas();

                    // Create a temporary canvas for colored signature
                    const coloredSignatureCanvas = document.createElement("canvas");
                    coloredSignatureCanvas.width = signatureCanvas.width;
                    coloredSignatureCanvas.height = signatureCanvas.height;
                    const coloredCtx = coloredSignatureCanvas.getContext("2d");

                    // Fill with white background
                    coloredCtx.fillStyle = "white";
                    coloredCtx.fillRect(0, 0, coloredSignatureCanvas.width, coloredSignatureCanvas.height);

                    // Apply color to the signature
                    coloredCtx.globalCompositeOperation = "source-over";
                    coloredCtx.fillStyle = "#000000"; // Black color for signature
                    coloredCtx.drawImage(signatureCanvas, 0, 0);

                    // Store the colored version
                    setSignatureData(coloredSignatureCanvas.toDataURL("image/png"));

                    // Draw on main canvas
                    ctx.drawImage(coloredSignatureCanvas, x, y);
                } else {
                    //draw typedSignature on same position
                    ctx.font = "bold 30px Arial";
                    ctx.fillStyle = signatureColor; // Use selected signature color
                    ctx.fillText(typedSignature, x, y);
                }

                // Draw the date
                ctx.font = "bold 30px Arial";
                ctx.fillStyle = "red";
                const dateX = canvas.width / 1.26;
                const dateY = canvas.height / 1.62;
                ctx.fillText(new Date().toLocaleDateString(), dateX, dateY);
            };
            img.src = Page3;
        }
    };
    const clearSignaturefrompagethree = () => {
        const canvas = document.getElementById("page3-canvas");
        if (canvas) {
            const ctx = canvas.getContext("2d");
            const img = new Image();
            img.onload = () => {
                const aspectRatio = img.width / img.height;
                canvas.width = img.width;
                canvas.height = canvas.width / aspectRatio;
                ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

                if (sigCanvasRef.current) {
                    const signatureCanvas = sigCanvasRef.current.getCanvas();
                    const x = canvas.width / 6.5;
                    const y = canvas.height / 1.7;

                    // Create a temporary canvas for colored signature
                    const coloredSignatureCanvas = document.createElement("canvas");
                    coloredSignatureCanvas.width = signatureCanvas.width;
                    coloredSignatureCanvas.height = signatureCanvas.height;
                    const coloredCtx = coloredSignatureCanvas.getContext("2d");

                    // Fill with white background
                    coloredCtx.fillStyle = "white";
                    coloredCtx.fillRect(0, 0, coloredSignatureCanvas.width, coloredSignatureCanvas.height);

                    // Apply color to the signature
                    coloredCtx.globalCompositeOperation = "source-over";
                    coloredCtx.fillStyle = "#000000"; // Black color for signature
                    coloredCtx.drawImage(signatureCanvas, 0, 0);

                    // Store the colored version
                    setSignatureData(coloredSignatureCanvas.toDataURL("image/png"));

                    // Draw on main canvas
                    ctx.drawImage(coloredSignatureCanvas, x, y);
                }

                // Redraw the date
                ctx.font = "bold 30px Arial";
                ctx.fillStyle = "red";
                const dateX = canvas.width / 1.26;
                const dateY = canvas.height / 1.62;
                ctx.fillText(new Date().toLocaleDateString(), dateX, dateY);
            };
            img.src = Page3;
        }
        setIsSigned(false);
    };
    useEffect(() => {
        // On activeStep change, scroll to top of the page
        window.scrollTo({ top: 0, behavior: "smooth" });
    }, [activeStep]);

    useEffect(() => {
        drawImageOnCanvas();
    }, [activeStep, signatureData, typedSignature]);

    const isDisabled = () => {
        if (!data.seller_address || nextLoading) {
            return true;
        }
    };

    const onClickPlayStore = () => {
        window.open("https://play.google.com/store/apps/details?id=com.airebrokers", "_blank");
    };

    const onClickAppStore = () => {
        window.open("https://apps.apple.com/pk/app/aire-brokers/id6742057602", "_blank");
    };

    return (
        <>
            <Header title="List Now" />
            <div className="tw-bg-background_color ">
                <Container className="tw-bg-background_color tw-pt-[55px]">
                    {(paymentLoading || success) && (
                        <div className="tw-max-w-3xl tw-w-full tw-rounded-3xl tw-bg-white tw-border-[1px] tw-border-background_secondary_color  tw-mt-[55px] tw-mx-auto ">
                            <div className="tw-flex tw-justify-center tw-mt-8">
                                <img src={HomeInspectorConfirmation} className="tw-w-[200px]" alt="" />
                            </div>

                            <div className="tw-rounded-lg tw-py-8  max-md:tw-px-8 tw-px-24 max-sm:tw-px-5 ">
                                <div className="tw-text-center tw-mb-8 ">
                                    <h1 className="tw-text-[32px] tw-font-bold tw-text-black tw-mb-2 ">Success! Your Property is Live!</h1>

                                    <p className="tw-text-black tw-text-[16px] tw-text-center ">
                                        Your listing is now active and visible to potential buyers or renters. Our team is reviewing it for maximum
                                        visibility.
                                    </p>
                                </div>
                                <div>
                                    <p className="tw-text-black tw-text-[18px] tw-font-bold tw-italic tw-text-center">
                                        Stay tuned for inquiries and updates!
                                    </p>
                                    <p className="tw-text-black tw-text-[16px] tw-text-center">
                                        Download our mobile app to manage your listing and receive real-time updates:
                                    </p>
                                    <div className="tw-flex tw-justify-center tw-my-8 tw-gap-3">
                                        <img src={AppStoreIcon} onClick={onClickAppStore} className="tw-w-[60px] tw-cursor-pointer" alt="" />
                                        <img src={PlayStoreIcon} onClick={onClickPlayStore} className="tw-w-[60px] tw-cursor-pointer" alt="" />
                                    </div>
                                </div>

                                <div className="tw-flex tw-flex-col tw-items-center lg:tw-flex-nowrap tw-gap-4">
                                    <button
                                        onClick={onCheckProperty}
                                        className="tw-bg-primary hover:tw-bg-primary_hover tw-w-fit tw-px-[100px] tw-text-white tw-h-[52px] tw-rounded-lg tw-transition-colors tw-text-sm"
                                    >
                                        Go To My Properties
                                    </button>
                                </div>
                            </div>
                        </div>
                    )}
                    {!success && (
                        <div className={`${paymentLoading ? "tw-hidden" : "tw-block"} tw-my-auto`}>
                            {activeStep !== 0 && (
                                <div className="tw-flex tw-justify-center tw-w-full">
                                    <Box sx={{ width: "100%" }}>
                                        <Stepper className="tw-mt-5" activeStep={activeStep} alternativeLabel>
                                            {steps.map((label, index) => {
                                                let currentStep =
                                                    activeStep === 1 || activeStep === 2 || activeStep === 3 || activeStep === 4 || activeStep === 5
                                                        ? activeStep - 1
                                                        : activeStep;
                                                return (
                                                    <Step key={label.label}>
                                                        <StepLabel
                                                            StepIconProps={{
                                                                style: {
                                                                    color: currentStep === index ? "#1ABC9C" : "#B2DFDB", // #B2DFDB is a lighter shade for inactive steps
                                                                },
                                                            }}
                                                        >
                                                            <p
                                                                style={{
                                                                    color: currentStep === index ? "#1ABC9C" : "#4F4F4F", // Using a neutral gray for non-active steps
                                                                }}
                                                                className="max-sm:tw-text-[10px] tw-font-medium"
                                                            >
                                                                {label.label}
                                                            </p>
                                                        </StepLabel>
                                                    </Step>
                                                );
                                            })}
                                        </Stepper>
                                    </Box>
                                </div>
                            )}
                            {activeStep === 0 ? (
                                <SellWelcomeScreen />
                            ) : activeStep === 3 ? (
                                <>
                                    <PackagesList
                                        setSelected_items={setSelected_items}
                                        setPackage_type={setPackage_type}
                                        setTotal_price={setTotal_price}
                                        setActiveStep={setActiveStep}
                                        package_type={package_type}
                                        handleBack={handleBack}
                                    />
                                </>
                            ) : (
                                <form
                                    onSubmit={handleSubmit}
                                    className={` ${activeStep !== 3 ? "" : "tw-grid-cols-[1fr,1fr,1fr] "}  tw-overflow-hidden tw-justify-center tw-w-full 
 `}
                                >
                                    <div
                                        style={{
                                            width: "100%",
                                            display: "flex",
                                            flexDirection: "column",
                                            gap: "10px",
                                        }}
                                    >
                                        <Snackbar open={openSnackbar} autoHideDuration={6000} onClose={handleCloseSnackbar}>
                                            <Alert onClose={handleCloseSnackbar} severity="error" sx={{ width: "100%" }}>
                                                {errorMessage}
                                            </Alert>
                                        </Snackbar>

                                        {activeStep === 1 && (
                                            <Container className="tw-flex tw-justify-center tw-w-[80%] max-sm:tw-w-full tw-mt-10 tw-rounded-md  tw-h-fit tw-p-[0.8rem]">
                                                <div className="user_details   tw-w-full tw-flex-row tw-flex tw-items-center">
                                                    <div className="input_pox">
                                                        <span className="datails tw-font-[800] tw-text-black" htmlFor="seller_address">
                                                            Address:
                                                        </span>
                                                        <PropertyAddressAutocomplete
                                                            initialValue={data.seller_address}
                                                            placeholder="Enter your property address"
                                                            onAddressSelect={(place) => {
                                                                const newData = {
                                                                    seller_address: place.formatted_address,
                                                                    latitude: place.latitude,
                                                                    longitude: place.longitude,
                                                                    city: getAddressComponent(place.address_components, "locality"),
                                                                    state: getAddressComponent(
                                                                        place.address_components,
                                                                        "administrative_area_level_1"
                                                                    ),
                                                                    zipCode: getAddressComponent(place.address_components, "postal_code"),
                                                                    unitNumber: getAddressComponent(place.address_components, "subpremise"),
                                                                };
                                                                setData((prev) => ({
                                                                    ...prev,
                                                                    ...newData,
                                                                }));
                                                                let storeData = {
                                                                    type: value || "",
                                                                    address: newData,
                                                                };
                                                                localStorage.setItem("sellAddress", JSON.stringify(storeData));
                                                                setAddressError(""); // Clear any previous error
                                                            }}
                                                        />

                                                        {addressError && <p className="tw-text-red-500">* {addressError}</p>}
                                                    </div>
                                                    <div className="input_pox">
                                                        <span className="datails  tw-font-[800] tw-text-black">Property Type</span>
                                                        <div className="tw-flex tw-justify-center">
                                                            <div className="tw-flex  tw-w-full tw-flex-col tw-items-center tw-gap-2">
                                                                <div className="tw-grid max-sm:tw-grid-cols-1 md:tw-grid-cols-2 xl:tw-grid-cols-4 max-sm:tw-grid-cols-0 tw-gap-4 tw-w-full ">
                                                                    {propertyTypes.map((item) => (
                                                                        <div
                                                                            key={item.value}
                                                                            onClick={() => {
                                                                                setValue(item.value);
                                                                                const newValue = {
                                                                                    type: item.value,
                                                                                    address: data,
                                                                                };
                                                                                localStorage.setItem("sellAddress", JSON.stringify(newValue));
                                                                            }}
                                                                            style={{
                                                                                borderRadius: "8px",
                                                                                padding: "30px ",
                                                                                textAlign: "center",
                                                                            }}
                                                                            className={`${value === item.value ? "tw-bg-primary hover:tw-bg-primary_hover" : "tw-bg-white"} tw-flex tw-flex-col tw-items-center tw-justify-center tw-gap-2 tw-border tw-cursor-pointer`}
                                                                        >
                                                                            <img
                                                                                style={{
                                                                                    width: "50px",
                                                                                    height: "50px",
                                                                                }}
                                                                                className={`${value === item.value && "tw-invert tw-filter"}  `}
                                                                                src={item.icon}
                                                                            />

                                                                            <p
                                                                                className="tw-text-wrap tw-text-[13px] tw-font-medium mx-2"
                                                                                style={{
                                                                                    color: value === item.value ? "#fff" : "#000000"
                                                                                }}
                                                                            >
                                                                                {item.display}
                                                                            </p>
                                                                        </div>
                                                                    ))}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </Container>
                                        )}
                                        {activeStep === 2 && (
                                            <Container className=" tw-min-h-[60vh] tw-overflow-auto tw-mt-5 ">
                                                <Box
                                                    sx={{
                                                        display: "flex",
                                                        flexDirection: "column",
                                                        justifyContent: "center",
                                                        width: "100%",
                                                        alignItems: "center",
                                                        flexWrap: "wrap",
                                                        "&::after": {
                                                            content: '""',
                                                            flex: "auto",
                                                        },
                                                    }}
                                                >
                                                    <div className="user_details tw-w-[100%]">
                                                        <div className="input_pox">
                                                            <SellImages
                                                                transaction_id={transaction_id}
                                                                imagesArr={imagesArr}
                                                                imagesForApi={imagesForApi}
                                                                setImagesForApi={setImagesForApi}
                                                                setImagesArr={setImagesArr}
                                                                labels={labels}
                                                                setlabels={setLabels}
                                                            />
                                                        </div>
                                                    </div>
                                                </Box>
                                            </Container>
                                        )}

                                        {activeStep === 4 && (
                                            <Container className="">
                                                <Box
                                                    sx={{
                                                        display: "flex",
                                                        flexDirection: "column",
                                                        justifyContent: "center",
                                                        alignItems: "center",
                                                        flexWrap: "wrap",
                                                        // padding: "2rem 0rem",
                                                        "&::after": {
                                                            content: '""',
                                                            flex: "auto",
                                                        },
                                                    }}
                                                >
                                                    <div className="tw-w-full tw-p-[2rem] max-sm:tw-px-0 tw-flex tw-flex-col xl:tw-flex-row tw-justify-between tw-gap-5">
                                                        <div className="tw-w-full xl:tw-w-1/2">
                                                            <div className="max-sm:tw-flex tw-flex-col tw-gap-2 max-sm:tw-items-center">
                                                                <label
                                                                    className="datails datails tw-font-[800] max-sm:tw-text-center  tw-text-black"
                                                                    htmlFor="seller_address"
                                                                >
                                                                    E- Sign your Contract
                                                                </label>
                                                            </div>
                                                            <div className="tw-my-5 tw-relative">
                                                                {signMethod === 0 && (
                                                                    <div className="tw-flex tw-flex-col tw-gap-1">
                                                                        {/* <p>Sign Here</p> */}
                                                                        <SignaturePad
                                                                            sigCanvas={sigCanvasRef}
                                                                            clearSignaturefrompagethree={clearSignaturefrompagethree}
                                                                            onEnd={() => {
                                                                                drawSignatureonPageThree();
                                                                                setIsSigned(true);
                                                                            }}
                                                                        />
                                                                    </div>
                                                                )}
                                                                {signMethod === 1 && (
                                                                    <div className="tw-flex tw-flex-col tw-gap-1">
                                                                        <TypeSignatureArea
                                                                            typedSignature={typedSignature}
                                                                            handleTypedSignatureChange={handleTypedSignatureChange}
                                                                            clearSignature={() => setTypedSignature("")}
                                                                            onColorChange={setSignatureColor}
                                                                        />
                                                                    </div>
                                                                )}
                                                                <div className="tw-absolute tw-top-3 tw-w-full tw-flex  tw-items-center tw-justify-center tw-gap-2">
                                                                    <div className="tw-w-fit tw-p-2 tw-border-1 tw-rounded-lg ">
                                                                        {tabs.map((tab) => (
                                                                            <button
                                                                                key={tab.id}
                                                                                onClick={() => {
                                                                                    setSignMethod(tab.id);
                                                                                    setIsSigned(false);
                                                                                }}
                                                                                className={`${signMethod === tab.id ? "tw-bg-primary hover:tw-bg-primary_hover tw-text-white tw-border-primary" : "tw-border-gray-300 tw-bg-white  tw-text-gray-700 "} tw-px-5 tw-py-2 tw-min-w-[120px] tw-font-medium tw-rounded-lg   tw-mr-2`}
                                                                            >
                                                                                {tab.label}
                                                                            </button>
                                                                        ))}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="tw-w-full xl:tw-w-1/2">
                                                            <div className="tw-flex tw-items-center tw-justify-between tw-gap-5">
                                                                <label className="datails" htmlFor="seller_address">
                                                                    Contract PDF Preview - Click to view full screen
                                                                </label>
                                                            </div>
                                                            <div className="tw-flex tw-gap-4 ">
                                                                <button
                                                                    onClick={() =>
                                                                        activePage < 2 ? setActivePage(4) : setActivePage(activePage - 1)
                                                                    }
                                                                    className="tw-mt-[120px] md:tw-mt-[250px] tw-w-[49px] tw-h-[42px] tw-flex tw-items-center tw-justify-center tw-bg-primary tw-rounded-md"
                                                                >
                                                                    <FaChevronLeft color="white" />
                                                                </button>
                                                                <div 
                                                                    className="tw-w-full tw-h-auto xl:tw-h-[600px] tw-relative tw-cursor-pointer tw-transition-all tw-duration-200 hover:tw-opacity-80 hover:tw-shadow-lg tw-border tw-border-transparent hover:tw-border-blue-300 tw-rounded-lg" 
                                                                    id="image-container"
                                                                    onClick={handleOpenContractModal}
                                                                    title="Click to view full contract"
                                                                >
                                                                    <div
                                                                        className={`pdf-image ${activePage === 1 ? "tw-block" : "tw-hidden"} tw-overflow-hidden tw-relative`}
                                                                    >
                                                                        <img src={Page1} alt="" className="tw-w-full tw-h-full tw-object-cover" />
                                                                        <p className="tw-absolute tw-top-[36%] tw-left-5 tw-text-black tw-text-[8px] md:tw-text-[10px] md:tw-font-bold">
                                                                            {profileData?.first_name} {profileData?.last_name}
                                                                        </p>
                                                                    </div>
                                                                    <img
                                                                        src={Page2}
                                                                        alt=""
                                                                        className={`pdf-image ${activePage === 2 ? "tw-block" : "tw-hidden"}`}
                                                                    />
                                                                    <canvas
                                                                        id="page3-canvas"
                                                                        className={`pdf-image ${activePage === 3 ? "tw-block" : "tw-hidden"}`}
                                                                    ></canvas>
                                                                    <div className="seller-date" id="currentDate"></div>
                                                                    <img
                                                                        src={Page4}
                                                                        alt=""
                                                                        className={`pdf-image ${activePage === 4 ? "tw-block" : "tw-hidden"}`}
                                                                    />
                                                                </div>
                                                                <button
                                                                    onClick={() =>
                                                                        activePage > 3 ? setActivePage(1) : setActivePage(activePage + 1)
                                                                    }
                                                                    className="tw-mt-[120px] md:tw-mt-[250px] tw-w-[49px] tw-h-[42px] tw-flex tw-items-center tw-justify-center tw-bg-primary tw-rounded-md"
                                                                >
                                                                    <FaChevronRight color="white" />
                                                                </button>
                                                                <br />
                                                            </div>
                                                        </div>
                                                        <br />
                                                    </div>
                                                    <div className="tw-flex tw-flex-col md:tw-flex-row tw-gap-2 tw-py-4">
                                                        <button
                                                            onClick={handleBack}
                                                            className="tw-px-[20px] tw-py-[15px] tw-border-1 tw-border-[#989898]  tw-bg-white tw-rounded-[8px]"
                                                        >
                                                            Cancel
                                                        </button>
                                                        <button
                                                            onClick={handleNext}
                                                            disabled={isAPiloading}
                                                            className="tw-px-[60px] tw-py-[15px] tw-text-white tw-bg-primary hover:tw-bg-primary_hover tw-rounded-[8px]"
                                                        >
                                                            {isAPiloading ? <CircularProgress size={20} color="inherit" /> : "Accept & Sign"}
                                                        </button>
                                                    </div>
                                                </Box>
                                            </Container>
                                        )}

                                        {activeStep === 5 && (
                                            <>
                                                <Container sx={{ padding: 0 }}>
                                                    <Box
                                                        sx={{
                                                            display: "flex",
                                                            flexDirection: {
                                                                xs: "column",
                                                                sm: "row",
                                                            },
                                                            justifyContent: "center",
                                                            alignItems: "center",
                                                            flexWrap: "wrap",
                                                            padding: 0,
                                                            "&::after": {
                                                                content: '""',
                                                                flex: "auto",
                                                            },
                                                        }}
                                                    >
                                                        <div className="tw-w-full ">
                                                            <StripeComponent
                                                                onPaymentSuccess={handlePaymentResponse}
                                                                onBack={handleBack}
                                                                setActiveStep={setActiveStep}
                                                                total_price={total_price}
                                                                package_type={package_type}
                                                                selected_items={selected_items}
                                                                onSetLoading={setPaymentLoading}
                                                                setSuccess={setSuccess}
                                                                showError={showError}
                                                                fullName={(data.first_name, data.last_name)}
                                                            />
                                                        </div>
                                                        {/* <div className="tw-w-full xl:tw-w-[30%]  tw-flex tw-items-center tw-justify-center tw-mt-5 ">
                                                        <Features />
                                                    </div> */}
                                                        <div className="user_details"></div>
                                                    </Box>
                                                </Container>
                                            </>
                                        )}

                                        {paymentSuccess && activeStep === steps.length && (
                                            <Container>
                                                <Box
                                                    sx={{
                                                        display: "flex",
                                                        flexDirection: "column",
                                                        justifyContent: "center",
                                                        alignItems: "center",
                                                        padding: "2rem",
                                                    }}
                                                >
                                                    <img src={successImage} alt="Success" style={{ height: "60vh", width: "100vh" }} />
                                                    <h3 style={{ textAlign: "center", color: "#232D8E" }}>Thank You!</h3>
                                                    <p
                                                        style={{
                                                            textAlign: "center",
                                                            color: "#8A8A8A",
                                                            marginBottom: "-7%",
                                                        }}
                                                    >
                                                        Your transaction has been successfully processed.
                                                    </p>
                                                </Box>
                                            </Container>
                                        )}

                                        {activeStep > 0 && activeStep !== 4 && activeStep !== 3 && activeStep !== 5 && (
                                            <div className="tw-flex tw-justify-center">
                                                <div className="navigation-buttons tw-mb-2 tw-mt-auto tw-justify-between tw-w-[80%]">
                                                    {activeStep !== steps.length - 1 && (
                                                        <button
                                                            name="submit"
                                                            className="prev-button tw-rounded-[8px] tw-bg-white tw-border tw-border-primary tw-text-gray-500 tw-px-4 tw-py-2 tw-shadow-sm tw-transition-colors tw-duration-200 tw-ease-in-out hover:tw-bg-gray-100 disabled:tw-cursor-not-allowed"
                                                            disabled={activeStep === 0}
                                                            onClick={handleBack}
                                                        >
                                                            Prev
                                                        </button>
                                                    )}
                                                    {activeStep < 6 && !paymentSuccess && (
                                                        <button
                                                            id="submit"
                                                            name="submit"
                                                            className={`next-button tw-rounded-[8px] tw-bg-primary hover:tw-bg-primary_hover tw-text-white tw-px-4 tw-py-2 tw-shadow-sm tw-transition-colors tw-duration-200 tw-ease-in-out  disabled:tw-bg-gray-300`}
                                                            onClick={handleNext}
                                                            disabled={isDisabled() || isAPiloading}
                                                        >
                                                            {nextLoading ? <CircularProgress size={24} /> : "Next"}
                                                        </button>
                                                    )}
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </form>
                            )}
                        </div>
                    )}
                    <>
                        {expandContract && (
                            <Modal
                                open={expandContract}
                                onClose={handleCloseExpandContract}
                                aria-labelledby="contract-preview-modal"
                                aria-describedby="modal-to-preview-contract"
                                closeAfterTransition
                            >
                                <Fade in={expandContract}>
                                    <Box
                                        sx={{
                                            // position: "absolute",
                                            top: "50%",
                                            left: "50%",
                                            transform: "translate(-50%, -50%)",
                                            width: "60vw",
                                            maxWidth: "800px",
                                            outline: "none",
                                            overflowY: "auto",
                                            maxHeight: "100vh",
                                            position: "relative",
                                            zIndex: 10,
                                        }}
                                    >
                                        <IconButton
                                            onClick={handleCloseExpandContract}
                                            sx={{
                                                position: "absolute",
                                                top: 25,
                                                right: 10,
                                                color: "var(--color-secondary)",
                                                zIndex: 20,
                                            }}
                                        >
                                            <CloseIcon />
                                        </IconButton>
                                        <div
                                            style={{
                                                display: "flex",
                                                justifyContent: "center",
                                                marginBottom: "10px",
                                            }}
                                        >
                                            <IconButton
                                                onClick={handleZoomIn}
                                                sx={{
                                                    position: "absolute",
                                                    top: 25,
                                                    left: 10,
                                                    color: "var(--color-secondary)",
                                                    zIndex: 20,
                                                }}
                                            >
                                                <ZoomInIcon />
                                            </IconButton>
                                            <IconButton
                                                onClick={handleZoomOut}
                                                sx={{
                                                    position: "absolute",
                                                    top: 25,
                                                    left: 40,
                                                    color: "var(--color-secondary)",
                                                    zIndex: 20,
                                                }}
                                            >
                                                <ZoomOutIcon />
                                            </IconButton>
                                        </div>
                                        <div
                                            className="image-container"
                                            style={{
                                                transform: `scale(${zoomLevel})`,
                                                transformOrigin: "center",
                                            }}
                                        >
                                            <img src={Page1} alt="Page 1" style={{ width: "100%" }} />
                                            <img src={Page2} alt="Page 2" style={{ width: "100%" }} />
                                            <canvas id="page3-canvas" style={{ width: "100%" }}></canvas>
                                            <img src={Page4} alt="Page 4" style={{ width: "100%" }} />
                                        </div>
                                    </Box>
                                </Fade>
                            </Modal>
                        )}
                    </>
                    
                    {/* Enhanced Contract Preview Modal */}
                    <ContractPreviewModal
                        open={showContractModal}
                        onClose={handleCloseContractModal}
                        pages={contractPages}
                        currentPage={activePage - 1}
                        signatures={{
                            signature: signatureData,
                            typedSignature: typedSignature,
                            signatureColor: signatureColor,
                            signMethod: signMethod
                        }}
                        profileData={profileData}
                        Page3Image={Page3}
                    />
                    
                    {previewModal && <PreviewPage navigate={navigate} id={previewModal} publicProperty={{}} setPreviewModal={setPreviewModal} />}
                </Container>
                {/* )} */}
                {isShowVerificaionPopup && <VerifyAccountPopup />}
            </div>
        </>
    );
}

export default Sell;
